import { Fragment, useMemo } from 'react';

import { Button } from '@playbooks/ui/components/button';
import { Icon } from '@playbooks/ui/components/icon';

const BtnPagination = ({ meta, params, setParams, taskRunning, onClick }) => {
	// Computed
	const computed = useMemo(() => {
		const used = (meta.page + 1) * meta.pageSize || 0;
		const remaining = meta.totalRecords - used || 0;
		const total = Math.ceil(meta.totalRecords / (meta.pageSize || 10000000)) || 0;
		return { used, remaining, total };
	}, [JSON.stringify(meta)]);

	// Render
	return (
		<Fragment>
			{meta.page + 1 < computed.total && (
				<Button
					variant='outline'
					size='lg'
					isLoading={taskRunning}
					onClick={() => onClick(meta.page + 1)}
					className='w-full'>
					<Icon data-icon='inline-start' type='far' icon='arrow-down' aria-hidden />
					Load more
				</Button>
			)}
		</Fragment>
	);
};

export { BtnPagination };
